/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import ActiveUserTable from '../usermanagement/components/ActiveUserTable';
import ApprovalUserTable from '../usermanagement/components/ApprovalUserTable';
import AddUser from '../usermanagement/components/AddUser';
import { isAuthorized } from '../../helpers/AuthUtils';
import commonEnLabels from '../../common/labels/common_en.json';
import AdminLogin from '../../common/components/AdminLogin';

let headerField = [
    {
        "id": "1",
        "steps": "Step 1",
        "name": "Approvals"
    },
    {
        "id": "2",
        "steps": "Step 2",
        "name": "All Active Users"
    }
]

const UserManagement = (props) => {
    const [stepName, setName] = useState("1");
    let [showModal, setShowModal] = useState(false);
    let [records, setRecords] = useState(0);

    const { authData } = useSelector(state => state.loginReducer, shallowEqual);
    let deptRoles = authData && authData.deptRoles && authData.deptRoles[0] && authData.deptRoles[0].roleId;
    const hasCreateUserPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true : isAuthorized(authData, null, "USER_MGMT", "C");
    const hasUpdateMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true : isAuthorized(authData, null, "USER_MGMT", "U");
    const hasDeletMasterPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true : isAuthorized(authData, null, "USER_MGMT", "D");

    return (
        <div className="tab-content border border-light" style={{ margin: "20px", top: "10px", width: '100%' }}>
            <div className='d-flex justify-content-between'>
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {headerField && headerField.map((ele, index) =>
                        <li className="nav-item" key={ele.id}>
                            <a href="#" className={stepName === ele.id ? "nav-link active" : "nav-link bg-profile-tabs"} value="home" id="home-tab" onClick={() => setName(ele.id)} data-toggle="tab" role="tab" aria-controls="home" aria-selected="false">
                                <span>{ele.name}</span>
                            </a>
                        </li>
                    )}
                </ul>
                <div className='d-flex justify-content-end col-md-2'>
                    {hasCreateUserPermission &&
                        <button type="button" className=" btn btn-primary custom_button  btn-sm p-2  "
                            style={{ right: 0, marginBottom: "5px" }}
                            onClick={() => { setShowModal(true) }}>
                            Add New User
                        </button>}
                </div>
            </div>


            <div className="tab-content border border-light" id="myTabContent" >
                <div className={stepName === "1" ? "tab-pane fade show active" : "tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" style={{ backgroundColor: "#ffff", boxShadow: "0 0 5px rgb(0 0 0 / 10%), inset 0 -2px 0 #dfe1e2" }}>
                    <ApprovalUserTable hasUpdateMasterPermission={hasUpdateMasterPermission} hasDeletMasterPermission={hasDeletMasterPermission} />
                </div>
                <div className={stepName === "2" ? "tab-pane fade show active" : "tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" style={{ backgroundColor: "#ffff" }}>
                    <ActiveUserTable hasUpdateMasterPermission={hasUpdateMasterPermission} hasDeletMasterPermission={hasDeletMasterPermission} />
                </div>
            </div>
            <AddUser
                showModal={showModal}
                setShowModal={setShowModal}
                header={"Add New User"}
            />
        </div>
    )
}

export default UserManagement;
